import styled from 'styled-components'
import image from '../../../assets/images/image.png'

export const PictureAreaDiv = styled.div`
min-height:450px;
display:flex;
flex-direction:row;
justify-content:center;

.roww{
    h4{
            font-family: Gilroy;
            font-style: normal;
            line-height: 30px;
            color: #FFFFFF;
        }
        p{
            padding-top:20px;
            font-family: Gilroy;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 25px;
            font-feature-settings: 'liga' off;

            color: rgba(255, 255, 255, 0.8);
            /* margin: 10px 0px; */
        }
 

}

.firstdiv{
        display:flex;
        flex-direction:column;
        text-align:start;
        border-radius:16px;
        background:linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0.1) 100%);
        /* background-image: url(${image}) */
        h4{
              padding-top:180px;
        }
        p{
            padding-top:20px;
        }
}
.seconddiv{
    display:flex;
    flex-direction:column;

    .firstsmall{
        /* height:50%; */
        border-radius:16px;
        background:linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0.1) 100%);
        /* background-image: url(${image}); */
        margin-top:5px;

    }
    .secondsmall{
        border-radius:16px;
        background:linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0.1) 100%);
        /* background-image: url(${image}); */
        height:50%;
        margin-top:5px;
        p{
            cursor: pointer;
        }
    }

}
.thirddiv{
        display:flex;
        flex-direction:column;
        text-align:start;
        border-radius:16px;
        background:linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0.1) 100%);
        /* background-image: url(${image}) */
        h4{
              padding-top:180px;
        }
        p{
            padding-top:20px;
        }
}

`